import { createMessage } from "./createMessage.mjs"
import { generateErrorMessage } from "./generateErrorMessage"

export async function fetchResource(url, body) {
    let response = null
    let retries = 0

    while(retries < 3) {
        try {
            if(body) {
                response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(body)
                })
            }
            else {
                response = await fetch(url)
            }
            
            if(response.status < 500) {
                break
            }

            retries++
        }
        catch(error) {
            retries++
        }
    }

    if(response === null) {
        return createMessage(false, generateErrorMessage(900), null, 900)
    }

    if(response.status != 200) {
        return createMessage(false, generateErrorMessage(response.status), null, response.status)
    }

    let json
    try {
        json = await response.json()
    }
    catch(error) {
        return createMessage(false, generateErrorMessage(901), null, 901)
    }

    return json
}